import React from "react";

const Footer = () => {
  return (
    <div>
      <footer className="uk-section uk-section-muted">
        <div className="uk-container uk-container-small">
          <h2 className="uk-dark" style={{ fontFamily: `"Teko", sans-serif` }}>
          Baca lebih lanjut tentang Belanjawan 2020
          </h2>
          <ul className="uk-grid uk-grid-match uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-light uk-margin-top uk-text-center" uk-scrollspy="target: > li; cls: uk-animation-slide-bottom; delay: 200;" uk-grid=" ">
					<li>
						<div className="uk-card uk-card-small uk-card-secondary uk-border-rounded uk-position-relative" style={{background:"#2A2B49"}}>
							<div className="uk-card-body uk-text-center">
								<div className="uk-margin-small-bottom uk-visible@s"><span uk-icon="icon:search;ratio:4" className="uk-icon"></span></div>
								<div className="uk-heading-small uk-text-light uk-margin-remove">
                  <span uk-icon="icon:search;ratio:2" className="uk-margin-small-right uk-hidden@s"></span>
                  <span className="uk-text-nowrap">Carta</span> 
                  <br className="uk-visible@s" />
                  &amp; Graf
                </div>
							</div>
							<div className="uk-card-footer uk-padding-remove-top uk-visible@s">
								<div className="uk-text-small uk-text-uppercase uk-margin-small-top" style={{letterSpacing:"1px;"}}>
									Infografik
								</div>
							</div>
							<a href="../infographic/" className="uk-position-cover" target="_top"></a>
						</div>
					</li>
					<li>
						<div className="uk-card uk-card-small uk-card-secondary uk-border-rounded uk-position-relative" style={{background:"#192176"}}>
							<div className="uk-card-body uk-text-center">
								<div className="uk-margin-small-bottom uk-visible@s"><span uk-icon="icon:question;ratio:4" className="uk-icon"></span></div>
								<div className="uk-heading-small uk-text-light uk-margin-remove">
									<span uk-icon="icon:question;ratio:2" className="uk-margin-small-right uk-hidden@s"></span>
                  Apa anda &nbsp;
                  <br className="uk-visible@s" />
                  dapat?
								</div>
							</div>
							<div className="uk-card-footer uk-padding-remove-top uk-visible@s">
								<div className="uk-text-small uk-text-uppercase uk-margin-small-top" style={{letterSpacing:"1px;"}}>
									Kuiz
								</div>
							</div>
							<a href="../quiz/" className="uk-position-cover" target="_top"></a>
						</div>
					</li>
					<li hidden>
						<div className="uk-card uk-card-small uk-card-secondary uk-border-rounded uk-position-relative uk-light" style={{background:"#D22E2F"}}>
							<div className="uk-card-body uk-text-center">
								<div className="uk-margin-small-bottom uk-visible@s"><span uk-icon="icon:heart;ratio:4" className="uk-icon"></span></div>
								<div className="uk-heading-small uk-text-light uk-margin-remove">
									<span uk-icon="icon:heart;ratio:2" className="uk-margin-small-right uk-hidden@s"></span>
                  Suka
                  <br className="uk-visible@s" />
                    atau tidak?
								</div>
							</div>
							<div className="uk-card-footer uk-padding-remove-top uk-visible@s">
								<div className="uk-text-small uk-text-uppercase uk-margin-small-top" style={{letterSpacing:"1px;"}}>
									Undian
								</div>
							</div>
							<a href="../poll/" className="uk-position-cover" target="_top"></a>
						</div>
					</li>
					<li className="uk-width-1-1@s uk-width-1-3@m">
						{/* <!-- TODO: Translate and change url --> */}
						<p className="uk-text-large uk-text-left" style={{color:"#000"}}>Baca laporan langsung 
            <a href="https://www.malaysiakini.com/news/495359" target="_top" style={{color:"#0277BD"}}> di sini &nbsp;</a>
            <span style={{color:"#FF5722"}}>&rarr;</span></p>
					</li>
				</ul>
          <hr />
        </div>
      </footer>
    </div>
  );
};

export default Footer;
